import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { QueryFunctionContext } from '@tanstack/react-query';
import {
  getBuyerFootprint,
  GetBuyerFootprintByStoreIdRequest,
} from 'services/api/jolectBuyerCenter';

export const jolectBuyerCenterQueries = createQueryKeys('jolectBuyerCenter', {
  footprint: (params: GetBuyerFootprintByStoreIdRequest) => ({
    queryKey: [params.storeId, params.sgNewClientId],
    queryFn: ({ signal }: QueryFunctionContext) =>
      getBuyerFootprint(params, signal).then((res) => res.data.data),
  }),
});
